module.exports = __webpack_public_path__ + "static/media/UPILogo.7a763741.svg";